import React, { useEffect } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { CorporateNavProvider, useCorporateNav } from '../context/CorporateNavContext';
import Navbar from '../components/Navbar';
import { loadCorporateProfile } from '../utils/corporateProfileStorage';
import { corporateSlugFromPathname } from '../config/corporateNav';

function CorporateWorkspaceShell() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setWorkspaceNav } = useCorporateNav() || {};
  const isWorkspaceScreen = Boolean(corporateSlugFromPathname(location.pathname));

  useEffect(() => {
    if (!isWorkspaceScreen) {
      setWorkspaceNav?.(null);
      return undefined;
    }
    const profile = loadCorporateProfile();
    if (!profile?.companyLegalName?.trim()) {
      navigate('/corporate', { replace: true });
      return undefined;
    }
    if (!setWorkspaceNav) return undefined;
    setWorkspaceNav({
      onEditProfile: () => navigate('/corporate?setup=1'),
    });
    return () => setWorkspaceNav(null);
  }, [isWorkspaceScreen, navigate, setWorkspaceNav]);

  return (
    <main className="critical-minerals-dashboard-main w-full">
      <Outlet />
    </main>
  );
}

/** Wraps /corporate — profile at index, workspace screens at /corporate/:screenSlug */
const CorporateRouteLayout = () => (
  <CorporateNavProvider>
    <div className="min-h-screen bg-white dark:bg-gray-900 transition-colors duration-200 w-full">
      <Navbar />
      <CorporateWorkspaceShell />
    </div>
  </CorporateNavProvider>
);

export default CorporateRouteLayout;
